/* Nynorsk tekst i Shopify sitt samtykkevindauge for informasjonskapslar */
(function () {
  var T = {
    'Cookie consent': 'Samtykke til informasjonskapslar',
    'We and our partners, including Shopify, use cookies and other technologies to personalize your experience, show you ads, and perform analytics, and we will not use cookies or other technologies for these purposes unless you accept them. Learn more in our': 'Vi og partnarane våre, mellom anna Shopify, bruker informasjonskapslar og andre teknologiar for å tilpasse opplevinga di, vise deg annonsar og utføre analysar. Vi bruker ikkje informasjonskapslar eller andre teknologiar til dette utan at du godtek det. Les meir i',
    'Privacy Policy': 'personvernerklæringa',
    'Manage preferences': 'Administrer innstillingar',
    'Accept': 'Godta',
    'Decline': 'Avslå',
    'Cookie and privacy preferences': 'Innstillingar for informasjonskapslar og personvern',
    'Accept all': 'Godta alle',
    'Decline all': 'Avslå alle',
    'Save my choices': 'Lagre vala mine',
    'You control your data': 'Du styrer dine eigne opplysningar',
    'Learn more about the cookies we use, and choose which cookies to allow.': 'Les meir om informasjonskapslane vi bruker, og vel kva informasjonskapslar du vil tillate.',
    'Required': 'Nødvendige',
    'These cookies are necessary for the site to function properly, including capabilities like logging in and adding items to the cart.': 'Desse informasjonskapslane er nødvendige for at nettstaden skal fungere som han skal, mellom anna for å logge inn og leggje varer i handlekorga.',
    'Personalization': 'Tilpassing',
    'These cookies store details about your actions to personalize your next visit to the website.': 'Desse informasjonskapslane lagrar detaljar om kva du gjer, slik at neste besøk på nettstaden blir tilpassa deg.',
    'Marketing': 'Marknadsføring',
    'These cookies are used by us and our partners, including Shopify, to optimize marketing communications and show you ads on other websites.': 'Desse informasjonskapslane blir brukte av oss og partnarane våre, mellom anna Shopify, til å forbetre marknadsføringa og vise deg annonsar på andre nettstader.',
    'Analytics': 'Statistikk',
    'These cookies help us understand how you interact with the site. We use this data to identify areas to improve.': 'Desse informasjonskapslane hjelper oss å forstå korleis du bruker nettstaden. Vi bruker opplysningane til å finne ut kva vi kan gjere betre.'
  };
  var A = { 'Close dialog': 'Lukk vindauget', 'Cookie consent': 'Samtykke til informasjonskapslar', 'Cookie and privacy preferences': 'Innstillingar for informasjonskapslar og personvern' };
  function norm(s) { return s.replace(/\s+/g, ' ').trim(); }
  function fix(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) {
      if (n.parentElement && n.parentElement.tagName === 'STYLE') continue;
      var k = norm(n.nodeValue);
      if (k && T[k]) {
        var lead = n.nodeValue.match(/^\s*/)[0], trail = n.nodeValue.match(/\s*$/)[0];
        n.nodeValue = lead + T[k] + trail;
      }
    }
    root.querySelectorAll('[aria-label]').forEach(function (e) { var v = A[norm(e.getAttribute('aria-label'))]; if (v) e.setAttribute('aria-label', v); });
  }
  function scan() {
    ['shopify-pc__banner', 'shopify-pc__prefs'].forEach(function (id) { var el = document.getElementById(id); if (el) fix(el); });
  }
  var t;
  var mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 30); });
  function start() { scan(); mo.observe(document.body, { childList: true, subtree: true, characterData: true }); }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
